/* src/app/views/area-publica/footer-area-publica/footer-area-publica.component.scss */
.footer-public {
  padding-left: 80px;
  padding-right: 80px;
  padding-top: 120px;
  padding-bottom: 120px;
  background-color: #2e3241;
  display: flex;
  justify-content: space-between;
  position: relative;
}
.subtitle-logo {
  color: white;
  font-size: 16px;
}
.footer-link {
  color: #B3D6ED;
}
.footer-links-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-self: center;
  align-items: flex-start;
}
.footer-container-content {
  width: 40%;
}
/*# sourceMappingURL=footer-area-publica.component.css.map */
